var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabletCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 3.125H4.375V18.125H15.625V3.125H13.125M6.875 10.625L9.375 13.125L13.75 8.75M6.875 1.875H13.125L12.3438 4.375H7.65625L6.875 1.875Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletCheck);
export default __webpack_public_path__ + "static/media/tablet-check.a4a36d164a3ae5882a9c4c84a7fe6298.svg";
export { ForwardRef as ReactComponent };